'use strict';

const checkParams = require('@mindmup/js-utils/src/check-params'),
	microsoftTeamsLegacyContextAdapter = require('./microsoft-teams-legacy-context-adapter');

module.exports = function MicrosoftTeamsShim(params) {
	checkParams(params, ['microsoftTeams']);
	const obj = this,
		{microsoftTeams} = params,
		getContext = async () => {
			const newContext = await microsoftTeams.app.getContext();
			return microsoftTeamsLegacyContextAdapter(newContext);
		},
		getIdentityToken = async () => {
			return microsoftTeams.authentication.getAuthToken();
		};

	microsoftTeams.app.initialize();

	obj.initializationComplete = () => {
		microsoftTeams.app.notifyAppLoaded();
		microsoftTeams.app.notifySuccess();
	};

	obj.registerOnSaveHandler = (doOnSave) => {
		if (!doOnSave || typeof doOnSave !== 'function') {
			throw new Error('invalid-args');
		}
		microsoftTeams.pages.config.setValidityState(true);

		const onSaveHandler = async saveEvent => {
			try {
				await doOnSave();
				saveEvent.notifySuccess();
			} catch (reason) {
				saveEvent.notifyFailure(reason);
			}

		};
		microsoftTeams.pages.config.registerOnSaveHandler(onSaveHandler);
	};
	obj.mindmupSaveEventResult = mindmupSaveEventResult => {
		checkParams(mindmupSaveEventResult, ['origin', 'fileId', 'title']);
		const {fileId, title} = mindmupSaveEventResult;
		microsoftTeams.pages.config.setConfig({
			websiteUrl: mindmupSaveEventResult.origin,
			contentUrl: mindmupSaveEventResult.contentUrl || `${mindmupSaveEventResult.origin}/microsoft-teams.html`,
			entityId: fileId,
			suggestedDisplayName: title
		});
	};
	obj.completeAuthentication = ({authResponse}) => microsoftTeams.authentication.notifySuccess(authResponse);
	obj.failAuthentication = (m) => microsoftTeams.authentication.notifyFailure(m || 'UnexpectedFailure');
	obj.authenticate = async (authPageUrl) => {
		if (!authPageUrl) {
			throw new Error('invalid-args');
		}
		return microsoftTeams.authentication.authenticate({
			url: authPageUrl,
			width: 600,
			height: 535
		});
	};
	Object.freeze(Object.assign(this, {getContext, getIdentityToken}));
};
